import { Slide } from "../../components/Carousel/carouselContents";
import ffwbcwHistory from "../../assets/images/ffwbcwHistory.png";
import ffwbcwMinistries from "../../assets/images/ffwbcwMinistries.png";
import ffwbcwHome from "../../assets/images/ffwbcwHome.png";
import ffwbcwPlan from "../../assets/images/ffwbcwPlan.png";

export const ffwbcwCarouselContents: Slide[] = [
  {
    cImg: `${ffwbcwHome}`,
    cAlt: "Screenshot of the Home page from ffwbcw.org",
  },
  {
    cImg: `${ffwbcwHistory}`,
    cAlt: "Screenshot of the History page from ffwbcw.org",
  },
  {
    cImg: `${ffwbcwPlan}`,
    cAlt: "Screenshot of the Plan Your Visit page from ffwbcw.org",
  },
  {
    cImg: `${ffwbcwMinistries}`,
    cAlt: "Screenshot of the Ministries page from ffwbcw.org",
  },
];
